<div class="retire-confirm-container">
  <form [formGroup]="retireFormGroup" (ngSubmit)="retireCharacter()">
    <div class="header">
      <h4>PLEASE READ AND CONFIRM</h4>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="closeModal()"
        >
        <img src="assets/icons/icon-close.svg" alt="" />
      </button>
    </div>
    <div class="retire-confirm-content">
      <p>
        Quick suggestion - Play the character out of the group game to the
        location you want them to retire and then use this selection. The wiki
        page will be updated so you might see them when passing through that
        location.
      </p>
      <p>
        By clicking Confirm, this character will be PERMANENTLY retired,
        concluding their interactive journey. The following will occur:
      </p>
      <ul>
        <li>
          An NPC Character icon will be placed where the retirement took place.
        </li>
        <li>
          Content created as this character / player will remain in the Players
          “store”
        </li>
        <li>Content created will still appear on the map where placed.</li>
        <li>
          Journal entries will integrated into their backstory and available on
          their wiki page.
        </li>
      </ul>
    </div>

    <div class="fc-box">
      <div class="form-check-b">
        <label>RETIRED</label>
        <input type="radio" value="is_retired" id="is_retired" formControlName="radio_choice" />
      </div>
      <div class="form-check-b">
        <label>DEAD</label>
        <input type="radio" value="is_dead" id="is_dead" formControlName="radio_choice" />
      </div>

    </div>
    @if (RadioChoice.getError('required')) {
      <div class="error">Please select an option</div>
    }

    <div class="add-gtop">
      <label class="form-label"
        >Describe what this character will do for the remainder of their
        days,<br />
        OR how they met there demise...</label
        >
        <textarea formControlName="status_description"></textarea>
      </div>
      <div class="btn-sec">
        <button class="btn btn-outline" (click)="closeModal()">Cancel</button>
        <button class="btn btn-danger" type="submit" [disabled]="retireFormGroup.invalid">Retire</button>
      </div>
    </form>
  </div>
